<ng-container *ngIf="showLabel">
    <label
        soho-label
        [required]="isRequired"p
        [attr.for]="id"
        [layoutInfo]="layoutInfo"
        lm-label
          [layoutField] = "field"
          [lmColumnLayoutInfo]="lmColumnLayoutInfo"
          [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
          [personalize]="personalize && !field?.label?.textStyle?.color"
        lm-text-style
        [textStyle]="field?.label?.textStyle"
    >{{triggerValue| formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
    </label>
</ng-container>
<div soho-rating
    #sohoRating
    (click)="onChangeRating($event)"
    (focusout)="onFieldBlur($event)">
    <fieldset>
        <ng-container *ngFor="let option of ratingOptions; index as i">
            <input
                type="radio"
                [ngClass]="option.class"
                name="{{ratingName}}"
                id="{{option.id}}"
                value="{{i}}">
            <label for="{{option.id}}">
                <svg #OptionSVG class="icon" focusable="false" aria-hidden="true" role="presentation">
                    <use [attr.xlink:href]="option.href"></use>
                </svg>
                <span class="audible">{{option.label}}</span>
            </label>
        </ng-container>
    </fieldset>
</div>
<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>
